/**
 * Organization capabilities — individual permissions that can be granted to members.
 * These map 1:1 to OpenFGA relations on the `organization` object type.
 */
export const ORGANIZATION_CAPABILITIES = [
	"org.manage_members",
	"org.manage_settings",
	"org.manage_subscription",
	"org.create_project",
	"org.view_all_projects",
	"org.manage_security",
	"org.manage_integrations",
	"org.manage_project_team_templates",
	"org.manage_work_packages",
] as const;

export type OrganizationCapability = (typeof ORGANIZATION_CAPABILITIES)[number];

export const normalizeOrganizationCapabilities = (
	capabilities: readonly OrganizationCapability[],
): OrganizationCapability[] => [...new Set(capabilities)];

/**
 * Map from capability key to the corresponding OpenFGA relation name.
 * The "org." prefix is stripped for FGA since FGA relations don't use it.
 */
export const CAPABILITY_TO_FGA_RELATION: Record<
	OrganizationCapability,
	string
> = {
	"org.manage_members": "can_manage_members",
	"org.manage_settings": "can_manage_settings",
	"org.manage_subscription": "can_manage_subscription",
	"org.create_project": "can_create_project",
	"org.view_all_projects": "can_view_all_projects",
	"org.manage_security": "can_manage_security",
	"org.manage_integrations": "can_manage_integrations",
	"org.manage_project_team_templates": "can_manage_project_team_templates",
	"org.manage_work_packages": "can_manage_work_packages",
};
